// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:07:11

export default {
  "id": "racing-car-destroying-zombie",
  "slug": "racing-car-destroying-zombie",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e5b1ceb6771f4109a4eded908659a1e5-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e5b1ceb6771f4109a4eded908659a1e5/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Racing Car Destroying Zombie",
      "description": "Zombie Racing Car fast-paced physics-based racing game. You’re in for the ride of your life through a zombie apocalypse!\n\nDrive your car through deserts, forests, abandoned city,...surrounded by zombies, earn cash, upgrade your car powerful ones. Steer your car to keep balance on the hills while trying to smash zombies into debris. It's you against a boatload of super-strong zombies!",
      "instructions": "Use Left Arrow, Right Arrow and press the shooting button, rotation button to control the car",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "car",
        "destroy",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "赛车摧毁僵尸",
      "description": "僵尸赛车是一款快节奏的基于物理的赛车游戏。你将经历一场终身难忘的僵尸末日之旅！\n\n驾驶你的赛车穿越沙漠、森林、废弃城市...周围都是僵尸，赚取现金，升级你的赛车，使其更加强大。在山丘上保持平衡的同时，尝试将僵尸撞成碎片。这是你和一群超级强壮僵尸的较量！",
      "instructions": "使用左箭头、右箭头并按下射击按钮、旋转按钮来控制汽车",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "汽车",
        "摧毁",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "賽車擊毀僵屍",
      "description": "僵屍賽車：一場快節奏的物理基礎賽車遊戲。你將在僵屍末日中體驗一輩子難忘的冒險！\n\n駕馭你的車在沙漠、森林、棄置的城市中穿行，周圍環繞著僵屍，賺取金錢，升級你的車輛成為強大的存在。在山丘上操控你的車輛保持平衡，同時試圖將僵屍撞成碎片。這是你對抗一群超強僵屍的時刻！",
      "instructions": "使用左箭頭、右箭頭及按射击按鈕、旋轉按鈕來控制車輛",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "車",
        "毀壞",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "賽車擊毀僵屍",
      "description": "僵尸競速車是一款快節奏的物理基礎賽車遊戲。你將在僵尸末日中享受一輩子難得的旅程！\n\n駕馭你的車輛穿越沙漠、森林、荒蕪的城市...並被僵尸包圍，賺取金錢，升級你的車輛成為強大的存在。在山丘上操控你的車輛保持平衡，同時試圖將僵尸擊中成碎片。這是你與一群強大的僵尸對決的時刻！",
      "instructions": "使用左方向鍵、右方向鍵及按擊射擊按鈕、旋轉按鈕來控制車輛",
      "genres": [
        "休闲",
        "賽車及駕駛"
      ],
      "tags": [
        "車輛",
        "毀壞",
        "僵屍"
      ]
    },
    "ja": {
      "title": "レーシングカーがゾンビを破壊中",
      "description": "ゾンビレーシングカーゲーム。高速な物理ベースのレースゲームで、ゾンビアポカリプスを通して一生の中で最も迫力のある旅を体験してください！\n\n砂漠、森、放棄された都市など、ゾンビに囲まれた場所を車で駆け巡り、お金を稼ぎ、車を強力なものにアップグレードしましょう。丘の上を走行しながら、ゾンビを破片にするために車を操りましょう。あなたは強力なゾンビたちに挑戦します！",
      "instructions": "左矢印、右矢印を使用し、射撃ボタン、回転ボタンを押して車を操作してください",
      "genres": [
        "カジュアル",
        "レーシング & ドライビング"
      ],
      "tags": [
        "車",
        "破壊",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "레이싱카가 죽은 씸을 파괴하는",
      "description": "좌시僵尸레이싱카 빠른 패시픽스 기반 레이싱 게임.僵尸 대기근을 통해 일생 만의 여행을 즐겨보세요!\n\n사막, 숲, 방치된 도시 등에僵尸로 둘러싸여 자동차를 몰라 현금을 벌고 자동차를 강력한 것으로 업그레이드하세요. 언덕을 올라가면서 자동차의 균형을 유지하면서僵尸를 파편으로 깨뜨려보세요. 이 게임에서는 강력한僵尸들과 맞서 싸워보세요!",
      "instructions": "왼쪽 방향키, 오른쪽 방향키를 사용하여 차를 이동하고, 발사 버튼, 회전 버튼을 눌러 조종하세요.",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "カー",
        "破壊",
        "ゾンビ"
      ]
    },
    "fr": {
      "title": "Voiture de course détruisant un zombie",
      "description": "Course de voitures de zombies rapide basée sur la physique. Vous êtes prêt pour la course de votre vie au cœur d'une apocalypse zombie !\n\nConduisez votre voiture à travers des déserts, des forêts, des villes abandonnées,... entouré de zombies, gagnez de l'argent, améliorez votre voiture avec des modèles puissants. Dirigez votre voiture pour maintenir l'équilibre sur les collines tout en essayant de frapper les zombies pour les transformer en débris. C'est vous contre une cargaison de zombies super forts !",
      "instructions": "Utilisez la flèche de gauche, la flèche de droite et appuyez sur le bouton de tir, le bouton de rotation pour contrôler la voiture",
      "genres": [
        "Facile",
        "Course et Conduite"
      ],
      "tags": [
        "car",
        "détruire",
        "zombie"
      ]
    }
  }
};
